import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { useFeatureFlag } from '../../../../../_hooks/useFeatureFlag';
import { Feature } from '../../../../../CommonSelectors/CommonArea.types';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';

interface Props extends MarginProps {
  formBag: UseFormReturn<any>;
  allowDocumentVaultPushNotifications: boolean;
  allowNewsfeedPushNotifications: boolean;
}

export const MobileAppNotifications = ({
  formBag,
  allowDocumentVaultPushNotifications,
  allowNewsfeedPushNotifications,
  ...rest
}: Props) => {
  const canConfigurePushNotifications = useFeatureFlag(Feature.PushNotifications);

  if (!canConfigurePushNotifications) {
    return null;
  }

  const allowMobileAppPushNotifications = formBag.watch('allowMobileAppPushNotifications');

  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Mobile App Notifications" />

      <Text fontSize="small" color="neutral.500" mt={-12} mb="16">
        These settings will only affect clients using the non-branded Orion Wealth Management Portal
        mobile app.
      </Text>

      <Toggle {...formBag.register('allowMobileAppPushNotifications')}>
        Allow Push Notifications
      </Toggle>

      {allowMobileAppPushNotifications && (
        <>
          {allowDocumentVaultPushNotifications && (
            <Toggle
              {...formBag.register('defaultDocumentUploadMobilePushNotifications')}
              ml="16"
              mt="8"
            >
              Document Uploads
            </Toggle>
          )}

          {allowNewsfeedPushNotifications && (
            <Toggle {...formBag.register('defaultNewsfeedMobilePushNotifications')} ml="16" mt="8">
              Newsfeed
            </Toggle>
          )}
        </>
      )}
    </Box>
  );
};
